import { FC } from 'react'
import { useTranslation } from 'next-i18next'

import { DummyProgress } from '../../common/components/DummyProgress'
import {
  ProgressStepContainer,
  ProgressStepTitleAndDescription,
} from '../../common/components/ProgressStep'

type StepTwoProps = {
  isCompleted: boolean

  className?: string
}

export const StepTwo: FC<StepTwoProps> = ({ isCompleted, className }) => {
  const { t } = useTranslation('common')

  return (
    <ProgressStepContainer className={className}>
      <ProgressStepTitleAndDescription>
        <h2>{t('Downloading Your Video...')}</h2>
        <p>
          {t(
            'Hang tight! This process could take a few minutes depending how large the video is.',
          )}
        </p>
      </ProgressStepTitleAndDescription>

      <DummyProgress isCompleted={isCompleted} />
    </ProgressStepContainer>
  )
}
